<template>
  <div>
    <div class="row">
      <!-- modals (edit) -->
      <modal :show.sync="modals" :showClose="false">
        <template slot="header">
          <h5 class="modal-title" id="exampleModalLabel">
            Shift Code Management
          </h5>
        </template>
        <div class="row">
          <div class="col-sm-12">
            <base-input
              label="Shift Code ID"
              v-model="ShiftCodeID"
              disabled
            ></base-input>
            <base-input label="Clock In">
              <el-time-picker
                v-model="ClockIn"
                value-format="HH:mm"
                :picker-options="{
                  format: 'hh:mm',
                }"
                placeholder="Clock In"
              ></el-time-picker>
            </base-input>
            <base-input label="Clock Out">
              <el-time-picker
                v-model="ClockOut"
                value-format="HH:mm"
                :picker-options="{
                  format: 'hh:mm',
                }"
                placeholder="Clock Out"
              ></el-time-picker>
              <!-- <el-time-select 
                :picker-options="{ step:'00:01'}" 
                placeholder="Clock Out" v-model="ClockOut "
              ></el-time-select> -->
            </base-input>
          </div>
        </div>

        <div
          class="col-sm-12 d-flex justify-content-between"
          style="margin-top: 1%"
        >
          <base-button type="success" @click="editShiftCode()"
            >Submit</base-button
          >
          <base-button type="warning" @click="modals = false"
            >Cancel</base-button
          >
        </div>
      </modal>

      <div class="col-lg-12 inline">
        <h2 style="display: inline">Shift Code Management</h2>
      </div>
      <div class="col-lg-12">
        <hr />
      </div>
      <div class="col-md-12">
        <card card-body-classes="table-full-width">
          <div>
            <div class="row">
              <div class="col-lg-8">
                <h4 class="card-title">List of Shift Code</h4>
              </div>
              <div class="col-lg-4 text-right" style="margin-bottom: 1%">
                <base-button @click="addShiftCode()" round type="green">
                  <i class="tim-icons icon-simple-add"></i>&nbsp;Add Shift Code
                </base-button>
              </div>
            </div>
            <div
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <base-input label="rows visible">
                <el-select
                  class="select-info mb-3 pagination-select"
                  v-model="pagination.perPage"
                  placeholder="Per page"
                >
                  <el-option
                    class="select-primary"
                    v-for="item in pagination.perPageOptions"
                    :key="item"
                    :label="item"
                    :value="item"
                  ></el-option>
                </el-select>
              </base-input>
              <base-input>
                <el-input
                  type="search"
                  class="mb-3 search-input"
                  clearable
                  prefix-icon="el-icon-search"
                  placeholder="Search records"
                  v-model="searchQuery"
                  aria-controls="datatables"
                ></el-input>
              </base-input>
            </div>
            <el-table
              :data="queriedData"
              :header-cell-style="{
                background: 'transparent',
                border: 'none',
                borderBottom: '0.5px solid #3d3f51',
              }"
              :cell-style="{
                border: 'none',
                borderBottom: '0.5px solid #3d3f51',
              }"
            >
              <el-table-column
                :min-width="150"
                prop="ShiftCodeID"
                label="Shift Code"
              ></el-table-column>
              <el-table-column
                :min-width="150"
                prop="ClockIn"
                label="Clock In"
              ></el-table-column>
              <el-table-column
                :min-width="150"
                prop="ClockOut"
                label="Clock Out"
              ></el-table-column>
              <!-- <el-table-column :min-width="150" prop="EmpID" label="Employee ID"></el-table-column>
              <el-table-column :min-width="150" prop="FirstName" label="First Name"></el-table-column>
              <el-table-column :min-width="150" prop="LastName" label="Last Name"></el-table-column>
              <el-table-column :min-width="150" prop="StartTime" label="Start Time"></el-table-column>
              <el-table-column :min-width="150" prop="EndTime" label="End Time"></el-table-column> -->
              <el-table-column :min-width="135" align="right" label="Actions">
                <div slot-scope="props">
                  <el-tooltip content="Edit" placement="bottom" effect="light">
                    <base-button
                      @click.native="getRow(props.$index, props.row)"
                      class="edit btn-link"
                      type="info"
                      size="sm"
                      icon
                    >
                      <i class="tim-icons icon-pencil"></i>
                    </base-button>
                  </el-tooltip>
                </div>
              </el-table-column>
            </el-table>
          </div>
          <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <div class>
              <p class="card-category">
                Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
              </p>
            </div>
            <base-pagination
              class="pagination-no-border"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
            ></base-pagination>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>
<script>
import LineChart from "src/components/Charts/LineChart";
import config from "@/config";
import * as chartConfigs from "@/components/Charts/config";
import { BaseProgress, Modal, BasePagination } from "src/components";
import {
  Table,
  TableColumn,
  Select,
  Option,
  TimeSelect,
  TimePicker,
  DatePicker,
} from "element-ui";
import Fuse from "fuse.js";
import moment from "moment";
import swal from "sweetalert2";

export default {
  components: {
    Modal,
    LineChart,
    BaseProgress,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [DatePicker.name]: DatePicker,
    [TimeSelect.name]: TimeSelect,
    [TimePicker.name]: TimePicker,
    BasePagination,
  },
  data() {
    return {
      //   startTime: "",
      //   endTime: "",
      ClockIn: "",
      ClockOut: "",
      ShiftCodeID: "",
      modals: false,
      modals2: false,
      selects: {
        selectTime: "",
        selectDept: "",
        selectArea: "",
        selectPos: "",
        selectEmp: "",
        time: [
          {
            value: "Daily",
            label: "Daily",
          },
          {
            value: "Weekly",
            label: "Weekly",
          },
          {
            value: "Monthly",
            label: "Monthly",
          },
          {
            value: "Yearly",
            label: "Yearly",
          },
        ],
        department: [
          {
            value: "ICWS",
            label: "ICWS",
          },
        ],
        area: [
          {
            value: "KL",
            label: "KL",
          },
        ],
        employee: [],
        position: [],
      },
      searchQuery: "",
      propsToSearch: ["ShiftCodeID"],
      tableData: [],
      searchedData: [],
      fuseSearch: null,
      currentRow: "",
      pagination: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0,
      },
    };
  },
  mounted() {
    // Fuse search initialization.
    this.fuseSearch = new Fuse(this.tableData, {
      keys: ["ShiftCodeID"],
      threshold: 0.3,
    });
  },
  computed: {
    /***
     * Returns a page from the searched data or the whole data. Search is performed in the watch section below
     */
    queriedData() {
      let result = this.tableData;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      }
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.tableData.length;
    },
  },

  methods: {
    getRow(index, row) {
      this.modals = true;
      this.currentRow = row;
      console.log(row);
      this.ShiftCodeID = row.ShiftCodeID;
      this.ClockIn = row.ClockIn;
      this.ClockOut = row.ClockOut;
    },
    handleEdit(row) {
      console.log(row);
      swal({
        title: "Are you sure?",
        text: `You want to edit ${row.EmpID}`,
        type: "info",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill",
        confirmButtonText: "Yes, edit it!",
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          // let body = {};
          // console.log(body);
          this.modals = false;
          swal({
            title: "Edited!",
            text: `You edited ${row.EmpID}`,
            type: "success",
            confirmButtonClass: "btn btn-success btn-fill",
            buttonsStyling: false,
          });
        }
      });
    },
    getShiftCode() {
      this.tableData = [];
      this.$http.get(":9995/api/v1/manage/shift").then((res) => {
        if (!res.error) {
          let data = res.message;
          console.log(data);
          for (var i = 0; i < data.length; i++) {
            let obj = {
              ShiftCodeID: data[i].ShiftCodeID,
              ClockIn: data[i].ClockIn,
              ClockOut: data[i].ClockOut,
            };
            this.tableData.push(obj);
          }
        }
      });
    },
    addShiftCode() {
      this.$router.push("/attendance/ShiftCodeManagementForm");
    },
    editShiftCode() {
      console.log(this.ShiftCodeID);
      console.log(this.ClockIn);
      console.log(this.ClockOut);

      let payload = {
        ShiftCodeID: this.ShiftCodeID,
        ClockIn: moment(this.ClockIn, "H:mm").format("H:mm"),
        ClockOut: moment(this.ClockOut, "H:mm").format("H:mm"),
      };

      // send
      this.$http.put(":9995/api/v1/manage/shift", payload).then((res) => {
        if (!res.error) {
          let data = res.message;
          console.log(data);
          swal({
            title: "Successful!",
            text: res.message,
            type: "success",
            confirmButtonClass: "btn btn-success btn-fill",
            confirmButtonText: "Okay",
            buttonsStyling: false,
          });
          this.modals = false;
          this.ShiftCodeID = "";
          this.ClockOut = "";
          this.ClockIn = "";
          this.getShiftCode();
        } else {
          swal({
            title: "Data Error!",
            text: `${res.message}`,
            type: "warning",
            confirmButtonClass: "btn btn-success btn-fill",
            confirmButtonText: "Okay",
            buttonsStyling: false,
          });
        }
      });
    },
  },
  created() {
    this.getShiftCode();
  },
  watch: {
    /**
     * Searches through the table data by a given query.
     * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
     * @param value of the query
     */
    searchQuery(value) {
      let result = this.tableData;
      if (value !== "") {
        result = this.fuseSearch.search(this.searchQuery);
      }
      this.searchedData = result;
    },
  },
};
</script>
<style lang="scss" scoped>
.footer-font {
  font-size: 105%;
}
.tab {
  margin-left: 1%;
  margin-right: 1%;
}
.test {
  width: 800px;
}
.dialog {
  margin-left: 30%;
}
</style>
